import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Link, Typography } from '@mui/material'
import PropTypes from 'prop-types'

import { ReactComponent as ChevronRightIcon } from '../../../assets/icons/circles-design/ChevronRightIcon.svg'
import { ReactComponent as SimIcon } from '../../../assets/icons/circles-design/SimIcon.svg'
import { ColorBoxContent } from '../../../common/ui/colorBox'
import useOrbitFlag from '../../../hooks/useOrbitFlag'

function ActivatedSimsCell({ bundle, bundleUsage }) {
  const navigate = useNavigate()
  const FlagSimIcon = useOrbitFlag('dashboard-activatedSims-simIcon')
  const FlagAddSim = useOrbitFlag('dashboard-activatedSims-addMore')
  return (
    <ColorBoxContent
      style={{
        display: 'flex',
        alignItems: 'center',
        height: '150px'
      }}
    >
      {FlagSimIcon && (
        <SimIcon
          style={{
            width: '100px',
            height: '100px',
            margin: `0 16px 0 0`
          }}
        />
      )}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center'
        }}
      >
        <Typography variant='h5' sx={{ marginBottom: '28px' }}>
          Activated SIMs
        </Typography>
        <Typography variant='h2' sx={{ margin: '0px 4px 16px' }}>
          {bundleUsage.activatedSims} / {bundle.sims}
        </Typography>

        {FlagAddSim && (
          <Link
            sx={{ fontSize: '16px', marginLeft: 0 }}
            onClick={() => navigate('/app/order/new')}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'column'
              }}
            >
              Add More SIMs
              <Box sx={{ marginLeft: 8 }}>
                <ChevronRightIcon />
              </Box>
            </Box>
          </Link>
        )}
      </Box>
    </ColorBoxContent>
  )
}

ActivatedSimsCell.propTypes = {
  bundle: PropTypes.object,
  bundleUsage: PropTypes.object
}

export default ActivatedSimsCell
